import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getOperatorFirstRideOfferInventory = async (operatorId: string) => {
  const response = await queryExecute({
    variables: { operatorId },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query OperatorFirstRideOfferInventory($operatorId: String!) {
        operatorFirstRideOfferInventory(operatorId: $operatorId) {
          operatorId
          inventory
          inventoryPerWeek
        }
      }
    `),
  });

  return response.data.operatorFirstRideOfferInventory!;
};
